exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dimtitle[data-v-01ce1fa7]{width:160px;height:22px;font-size:14px;font-weight:400;color:#436bff;line-height:22px;cursor:pointer}.dimtitle1[data-v-01ce1fa7]{height:36px}.w104[data-v-01ce1fa7]{width:104px}.w182[data-v-01ce1fa7]{width:182px}.w74[data-v-01ce1fa7]{width:74px}.bgray[data-v-01ce1fa7]{background:#f9f9f9;border-radius:5px}\n", ""]);

